import FeatureGates from '@atlaskit/feature-gate-js-client';

// These are the experiment keys for our experiments created on Statsig.
export var AI_EXPERIMENTS = {
  // Replaces "platform.editor.ai-persistent-placeholder"
  'editor_ai_-_persistent_placeholder_experiment': ['control', 'persistent-placeholder'],
  'editor_ai_-_gpt4_experiment': ['control', 'einstein'],
  'editor_ai_-_proactive_ai_model_variations': ['control', 'skip_grammar'],
  'editor_ai_-_proactive_ai_spelling_and_grammar': ['control', 'default-off', 'default-on'],
  'platform_editor_ai-prompts-placeholder': ['control', 'test']
};
/**
 * Reads the cohort (experiment bucket) which the current user is part of
 * for the given `experimentKey`.
 *
 * @param experimentKey string to ideitfy the experiment.
 * @returns T|'not-enrolled' The cohort the user is part of, or 'not-enrolled'
 * if the user landed into the non-targeted segment (if rollout is < 100% or experiment paused)
 */
export var getExperimentCohort = function getExperimentCohort(experimentKey) {
  var getExperimentValue = FeatureGates.getExperimentValue;
  return getExperimentValue(experimentKey, 'cohort', 'not-enrolled');
};
export var getMockedGetExperimentValue = function getMockedGetExperimentValue(key, cohort) {
  return function (experimentKey, parameter) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (experimentKey === key) {
      if (parameter === 'cohort') {
        return cohort;
      } else if (parameter === 'isEnabled') {
        return true;
      }
    }
    return defaultValue;
  };
};